/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 14:28:57
 * @Description: file content
 */ 
import React, { Component } from 'react';
import { Alert as OriginAlert } from "@tinper/next-ui";
// import OriginAlert from 'bee-alert';
// require('bee-alert/build/Alert.css');
// import "./index.less";
/**
 * @namespace Alert
 */

/**
 * 警告提示Alert组件的参数描述
 * @memberof Alert
 * @component Alert
 * @property {string} id - 警告提示的 id
 * @property {string} fieldid - fieldid【自动化测试专用属性】
 * @property {string} className - 类名
 * @property {string} [type=info] - 指定警告提示的样式，有四种选择 success、info、warning、danger
 * @property {ReactNode} closeText - 关闭按钮自定义展示
 * @property {function} onClose - 关闭 alert 触发的方法
 * @property {boolean} [dark=false] - 显示颜色深度
 * @property {boolean} [closable=true] - 默认显示关闭按钮
 * @property {ReactNode} message - 警告提示内容
 * @property {ReactNode} description - 警告提示的辅助性文字介绍
 * @property {boolean} showIcon - 是否显示辅助图标
 */
class Alert extends Component {
    render() { 
        return <OriginAlert 
            {...this.props} 			
        />;
    }
}
 
export default Alert;
